import { useState, useEffect } from 'react';
import axios from 'axios';
import { VRP_ALGORITHMS_API } from '../../../../../config';
import { DEFAULT_ALGORITHMS } from '../constants';

/**
 * Custom hook to load and manage algorithms data
 */
export const useAlgorithms = () => {
  const [algorithms, setAlgorithms] = useState(DEFAULT_ALGORITHMS);
  const [isLoadingAlgorithms, setLoadingAlgorithms] = useState(true);
  const [selectedAlgorithm, setSelectedAlgorithm] = useState('capacitated_savings');
  const [error, setError] = useState('');

  // Load algorithm data
  useEffect(() => {
    loadAlgorithms();
  }, []);

  // Load algorithm data from API
  const loadAlgorithms = async () => {
    try {
      setLoadingAlgorithms(true);
      setError('');
      
      const response = await axios.get(VRP_ALGORITHMS_API);
      if (response.data.success) {
        // Use VRP specific algorithm list
        const vrpAlgorithms = response.data.data.vrp_algorithms || [];
        const allAlgorithms = response.data.data.all_algorithms || [];
        const algorithmsInfo = response.data.data.algorithms_info || {};
        
        // Prioritize VRP algorithms, use all algorithms if none available
        const availableAlgorithms = vrpAlgorithms.length > 0 ? vrpAlgorithms : allAlgorithms;
        
        // Convert all available algorithms to required format (removed capacity filtering)
        const formattedAlgorithms = {};
        for (const algId of availableAlgorithms) {
          if (algorithmsInfo[algId]) {
            formattedAlgorithms[algId] = algorithmsInfo[algId];
          }
        }
        
        setAlgorithms(formattedAlgorithms);
        
        // Force select capacitated_savings as default algorithm if available
        if (availableAlgorithms.includes('capacitated_savings')) {
          setSelectedAlgorithm('capacitated_savings');

        } else if (availableAlgorithms.length > 0) {
          // Fall back to first available algorithm
          const defaultAlgorithm = availableAlgorithms[0];
          setSelectedAlgorithm(defaultAlgorithm);

        }
      }
    } catch (error) {
      console.error('Failed to load algorithm data:', error);
      setError('Failed to load algorithm data');
    } finally {
      setLoadingAlgorithms(false);
    }
  };

  // Handle algorithm selection change
  const handleAlgorithmChange = (e) => {
    setSelectedAlgorithm(e.target.value);
  };

  return {
    algorithms,
    isLoadingAlgorithms,
    selectedAlgorithm,
    setSelectedAlgorithm,
    handleAlgorithmChange,
    error,
    loadAlgorithms
  };
}; 